<template>
	<div
		:class="`flex items-center justify-start border-b border-ihh-gray/50 cursor-pointer transition-colors duration-200 hover:bg-ihh-slate-gray/10 active:bg-ihh-slate-gray/20 ${isActive ? 'bg-ihh-slate-gray/10 font-semibold' : ''} ${isActive && option.hasContent ? 'pt-4' : ''}`"
		@click="$emit('selected', option.id)"
	>
		<div class="flex flex-col w-full justify-center px-2">
			<!-- Row Header -->
			<div class="flex items-center h-14">
				<!-- selection circle (desktop) / chevron (mobile) -->
				<div class="relative md:w-10 md:h-10 flex items-center justify-center md:mx-2">
					<!-- Desktop Selection Circle -->
					<div
						:class="[
							'absolute items-center rounded-full w-6 h-6 transition-all hidden md:block',
							{
								'bg-ihh-dark-salmon ring-1 ring-ihh-dark-salmon ring-offset-[3px]': isActive,
								'border border-ihh-gray bg-ihh-white text-ihh-midnight-gray/70': !isActive,
							},
						]"
					/>
					<!-- Mobile Chevron -->
					<!-- <div class="md:hidden transition-transform duration-200" :class="{ 'rotate-180': isActive }">
						<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-ihh-midnight-gray/70" viewBox="0 0 20 20" fill="currentColor">
							<path
								fill-rule="evenodd"
								d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
								clip-rule="evenodd"
							/>
						</svg>
					</div> -->
				</div>

				<!-- Option Name & Images -->
				<div class="w-full md:pl-2 flex items-center space-x-1 text-sm">
					<!-- <span :class="option.img === null || option.id === 'ach' ? 'hidden' : 'flex'" class="w-full max-w-20 justify-start md:block hidden">
						<img :src="option.img" :class="['flex w-12 justify-start', { 'mr-3': option.img }]" />
					</span> -->

					<div class="flex justify-between w-full items-center md:whitespace-nowrap md:pl-0 pl-0">
						<!-- Payment Method Name -->
						<div class="md:pl-0 pl-0">{{ option.method }}</div>

						<div v-if="option.creditCards" class="flex justify-end">
							<div class="flex space-x-1">
								<img src="/images/visa-edited.png" class="w-10 h-6 bg-ihh-white border rounded p-1" />
								<img src="/images/master-edited.png" class="w-10 h-6 bg-ihh-white border rounded p-1" />
								<img src="/images/amex-edited.png" class="w-10 h-6 border rounded p-1" />
								<img :class="option.id === 'google-pay' ? 'hidden' : ''" src="/images/discover-edited.png" class="w-10 h-6 border rounded p-1" />
							</div>
						</div>
						<div v-if="option.id === 'digitalWallets'" class="flex justify-end items-end">
							<div class="flex space-x-1">
								<img src="/images/paypal-2p-edited.png" class="w-10 h-6 bg-ihh-white border rounded p-1" />
								<img src="/images/venmo-edited.png" class="w-10 h-6 bg-ihh-white border rounded p-1" />
								<img src="/images/apple-pay.png" class="w-10 h-6 bg-ihh-white border rounded p-1" />
								<img src="/images/google-pay.png" class="w-10 h-6 bg-ihh-white border rounded p-1" />
							</div>
						</div>
						<div v-if="option.id === 'ach'" class="flex justify-end">
							<div class="bg-[#1524D9] h-[24px] w-[40px] flex justify-center items-center rounded text-white font-bold text-2xs tracking-widest">ACH</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Row Details -->
			<div v-show="isActive" class="flex flex-col items-center md:px-16 w-full" :class="{ 'mb-8': option.hasContent }">
				<slot name="content"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PaymentOption',
	emits: ['selected'],
	props: {
		option: {
			type: Object,
			required: true,
		},
		selectedOptionId: {
			type: String,
			default: 'cards',
		},
	},
	data() {
		return {}
	},
	methods: {},

	computed: {
		isActive() {
			return this.option.id === this.selectedOptionId
		},
	},
}
</script>

<style scoped>
.ach-logo {
	align-self: center;
	display: flex;
	height: 1.9230769231rem;
	object-fit: contain;
	max-width: 100%;
	vertical-align: middle;
	border: 0;
	box-sizing: border-box;
	overflow-clip-margin: content-box;
	overflow: clip;
}
</style>
